import React, { useContext } from 'react'

import { TitleContext } from '@providers/TitleProvider'

import ActivateEEButton from '../../ActivateEEButton'
import Avatar from '../../Avatar'
import FollowLink from './FollowLink'
import NumberFollowers from './NumberFollowers'
import SellerNameLink from './SellerNameLink'

/**
 * Seller is a bit of a misnomer in the case EE books
 * EE books are sold by Hal but the seller name is the name of the book
 */
const Index: React.FC = () => {
  const {
    title: { seller },
  } = useContext(TitleContext)

  if (!seller) return null

  return (
    <section className="py-4 flex flex-row items-center justify-between">
      <div className="flex flex-row items-center h-10 flex-1">
        <Avatar url={seller.avatar} />
        <div>
          <SellerNameLink />
          <NumberFollowers />
        </div>
      </div>
      <ActivateEEButton />
      <FollowLink />
    </section>
  )
}

export default Index
